/**
 * Application Configuration
 * Single source of truth for environment-driven settings consumed by the web client.
 * All VITE_* variables are set at build time and read here; no other file should
 * reference import.meta.env directly (except this one).
 */

/**
 * Base URL for the REST API (no trailing slash). Unset (local dev), it's the
 * page's own address — the Vite dev server forwards /api to the server — so
 * the app works however it's opened: localhost, or the PC's LAN address from
 * a phone (where "localhost:3001" would be the phone itself).
 */
export const getApiUrl = (): string =>
  (import.meta.env.VITE_API_URL as string | undefined) || '/api';

/** Base URL for the WebSocket server. Unset, the page's own address (Vite forwards /socket.io). */
export const getSocketUrl = (): string =>
  (import.meta.env.VITE_SOCKET_URL as string | undefined) || window.location.origin;

/** Current runtime environment label. */
export const ENV = (import.meta.env.VITE_ENV as string | undefined) || 'development';

export const IS_PRODUCTION = ENV === 'production';

/** Whether to offer sign-up (the server has the final say). Off on the private test server. */
export const REGISTRATION_OPEN = (import.meta.env.VITE_REGISTRATION_OPEN as string | undefined) !== 'false';

// ---------------------------------------------------------------------------
// Auth / storage
// ---------------------------------------------------------------------------

/** localStorage key used to persist the JWT access token. */
export const TOKEN_STORAGE_KEY = 'token';

/** localStorage key used to persist the serialised user object. */
export const USER_STORAGE_KEY = 'user';

// ---------------------------------------------------------------------------
// Admin dashboard
// ---------------------------------------------------------------------------

/** How often (ms) the admin System Settings page polls live system stats. */
export const ADMIN_SYSTEM_POLL_INTERVAL_MS =
  Number(import.meta.env.VITE_ADMIN_SYSTEM_POLL_INTERVAL_MS) || 5_000;

/** How often (ms) the lobby polls for new tables. */
export const LOBBY_POLL_INTERVAL_MS =
  Number(import.meta.env.VITE_LOBBY_POLL_INTERVAL_MS) || 10_000;
